export const GENERAL_TYPE = 1;
export const AUTO_RV_TYPE = 2;
export const VISA_CONSUMER_TYPE = 3;
export const MORTGAGE_TYPE = 4;
export const DEPOSIT_TYPE = 5;